import { render, staticRenderFns } from "./ChatHistoryBox.vue?vue&type=template&id=bf7c4f64&scoped=true&"
import script from "./ChatHistoryBox.vue?vue&type=script&lang=js&"
export * from "./ChatHistoryBox.vue?vue&type=script&lang=js&"
import style0 from "./ChatHistoryBox.vue?vue&type=style&index=0&id=bf7c4f64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7c4f64",
  null
  
)

export default component.exports